import React from 'react';

const ImagePost = ({ 
  post, 
  images, 
  currentImageSlide, 
  hasMultipleImages, 
  isImageDragging, 
  imageDragOffset, 
  imageHandlers 
}) => {
  return (
    <div 
      className={`${post.backgroundStyle} aspect-square rounded-xl relative overflow-hidden transition-all duration-500 hover:scale-[1.01] w-full ${
        hasMultipleImages ? "cursor-grab" : ""
      } ${isImageDragging ? "cursor-grabbing" : ""}`}
      {...(hasMultipleImages ? imageHandlers : {})}
      style={{
        touchAction: hasMultipleImages ? "pan-y" : "auto",
        userSelect: isImageDragging ? "none" : "auto",
      }}
    >
      {/* Image Counter - Top Right */}
      {hasMultipleImages && (
        <div className="absolute top-3 right-3 z-20 pointer-events-none">
          <span className="text-xs font-medium px-2 py-1 rounded-full bg-black/50 text-white">
            {currentImageSlide + 1}/{images.length}
          </span>
        </div>
      )}

      {/* Image Indicators - Bottom Center */}
      {hasMultipleImages && images.length > 1 && (
        <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 flex space-x-1 z-20 pointer-events-none">
          {images.map((_, index) => (
            <div
              key={index}
              className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                index === currentImageSlide
                  ? 'bg-white'
                  : 'bg-white/30'
              }`}
            />
          ))}
        </div>
      )}

      {/* Sliding Images Container */}
      <div 
        className={`flex h-full w-full ${
          isImageDragging
            ? ""
            : "transition-transform duration-500 ease-out"
        }`}
        style={{
          transform: `translateX(${
            -currentImageSlide * 100 + imageDragOffset / 4
          }%)`,
        }}
      >
        {images.map((imageUrl, index) => (
          <div 
            key={index}
            className="w-full h-full flex-shrink-0"
          >
            <img 
              src={imageUrl} 
              alt={`Post image ${index + 1}`}
              className="w-full h-full object-contain"
              draggable={false}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImagePost;